import { useEffect } from "react";

import { Box } from "@mui/material";

import type { SxProps, Theme } from "@mui/material";

interface HowdyGoEmbeddedDemoProps {
  publicationId: string;
  sx?: SxProps<Theme>;
}

function HowdyGoEmbeddedDemo(props: HowdyGoEmbeddedDemoProps) {
  const { publicationId, sx = {} } = props;

  useEffect(() => {
    const scriptId = "howdygo-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://js.howdygo.com/v1.1x/index.js";
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <Box
      sx={[
        {
          boxSizing: "content-box",
          position: "relative",
          maxWidth: "2560px",
          aspectRatio: "2560 / 1308",
          paddingBottom: "40px",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          boxShadow:
            "0px 0px 1px rgba(45, 55, 72, 0.05), 0px 4px 8px rgba(45, 55, 72, 0.1)",
          overflow: "hidden",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <iframe
        src={`https://app.howdygo.com/embed/${publicationId}`}
        title="HowdyGo Demo"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </Box>
  );
}

export default HowdyGoEmbeddedDemo;
